import React, {Component} from 'react';
import ReactTable from 'react-table';

import {Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Row,} from 'reactstrap';
import {Line} from 'react-chartjs-2';
import moment from 'moment';
import {connect} from 'react-redux';
import {closeAlert} from '../../../actions/commonsActions';
import {USER_ROLES,} from '../../../helpers/constants';
import Pagination from '../../Pagination/Pagination';

// Datetime picker plugin file
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css';

import 'react-table/react-table.css';
import './store-stat.css';
import {fetchCompanies} from "../../../actions/companyActions";
import {fetchStoreStats, filteringStoreStats} from "../../../actions/statsActions";
import {getColorsObject} from "../../../helpers/getRandomRgb";
import nanoid from "nanoid";
import {I18n} from "../../../I18n/components/statistics";
import {isStatisticPermission} from "../../../helpers/companyService";
import swal from "sweetalert";

//Line chart
let lineData = {
	labels: [1, 2, 3, 4, 5, 6, 7, 8],
	datasets: [{
		label: 'Name',
		borderWidth: 1,
		backgroundColor: 'rgba(94,114,228,.1)',
		borderColor: 'rgb(94,114,228)',
		pointBorderColor: 'rgb(94,114,228)',
		pointBackgroundColor: 'rgb(94,114,228)',
		data: [0, 15, 6, 11, 25, 9, 18, 24]
	}]
};

class StoreStat extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
			dateTo: moment().format('YYYY-MM-DD'),
            storeId: null,
			color: '',
			loading: true
		};

	}

	componentDidMount() {
		if (!isStatisticPermission(this.props.companies[0], this.props.authority)) {
			swal(
				I18n[this.props.lang].general.contactUsToAccessThis,
				"",
				"error")
			this.setState({
				loading: false,
			})
			return
		}
		(async () => {

            const urlParams = new URLSearchParams(window.location.search);
            const companyId = urlParams.has('cid') ? urlParams.get('cid') : null;
			const dateFrom = urlParams.has('dateFrom') ? urlParams.get('dateFrom') : null;
			const dateTo = urlParams.has('dateTo') ? urlParams.get('dateTo') : null;
			// if (!companyId) {
			// 	await this.props.fetchCompanies();
			// }
			const storeId = this.props.match && this.props.match.params && this.props.match.params.storeid ?
				this.props.match.params.storeid : null;
			if (storeId) {
				await this.props.fetchStoreStats(storeId, {
					dateFrom,
					dateTo
				});
				this.setState({
                    storeId: storeId ? +storeId : null,
					storeName: this.props.stats && this.props.stats.salesPointName ? this.props.stats.salesPointName : '',
					companyId: companyId ? companyId : this.props.companies[0].id,
					dateFrom : dateFrom,
					dateTo: dateTo,
					loading: false,
					color: getColorsObject(0.1)
				})
			} else {
				this.setState({
					dateFrom : dateFrom,
					dateTo: dateTo,
					loading: false,
					color: getColorsObject(0.1)
				});
			}
		})();
	}

    onFilterClick = event => {
        const value = event.target.value;
        this.props.filteringStoreStats(value);
    };

	dateToTimeChange = moment => {
		this.setState({
			dateTo: moment.format('YYYY-MM-DD')
		})
	};

	dateFromTimeChange = moment => {
		this.setState({
			dateFrom: moment.format('YYYY-MM-DD')
		})
	};

	getFiltered = async () => {
        await this.props.fetchStoreStats(this.state.storeId, {
			dateFrom: this.state.dateFrom,
			dateTo: this.state.dateTo
		});
		this.setState({
			color: getColorsObject(0.1)
		})
	};

	clearFilters = () => {
		this.setState({
			dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
			dateTo: moment().format('YYYY-MM-DD'),
		}, async () => {
            await this.props.fetchCompanyStats(this.state.companyId, {
				dateFrom: this.state.dateFrom,
				dateTo: this.state.dateTo
			});
			this.setState({
				color: getColorsObject(0.1)
			})
		})
	};

	render() {
        const {stats, lang} = this.props;
        const {loading} = this.state;
        console.log('loading', loading)
		return (
			<div className='store-stats'>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Card>
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].point.title} {this.state.storeName}
						</div>
					</CardTitle>

					<CardBody>
						{
							(() => {
								if (loading) {
									return <div className="loading">Loading...</div>;
								} else {
                                    let pointsLabels = [];
                                    let pointsDataSets = [];
                                    let dataValue = [];

                                    if (stats && stats.chartPoints) {
                                    	const color = this.state.color;
                                        dataValue = stats.chartPoints && stats.chartPoints.length ?
                                            stats.chartPoints.map(elem => elem.value) : [];
                                        pointsDataSets = [{
                                            label: stats.salesPointName,
                                            data: dataValue,
                                            //fill: false,
                                            borderWidth: 1,
                                            backgroundColor: color ? color.opacityColor : '',
                                            borderColor: color? color.mainColor : '',
                                            pointBorderColor: color? color.mainColor : '',
                                            pointBackgroundColor: color? color.mainColor : ''
                                        }];
                                        pointsLabels = stats.chartPoints && stats.chartPoints.length ?
											stats.chartPoints.map(elem => elem.label) : [];
                                    }
                                    const data = this.props.filteredStats || this.props.uploadReports;
									const tableData = data.map((item, i) => {
										return {
											id: i,
											producer: item.phone,
											model: item.phoneModel,
											imei: item.phoneImei,
											serial: item.phoneSerial,
											version: item.androidVersion,
											pocket: item.abi,
											status: item.status,
											time: item.dateTime,
											item: item
										};
									});
									return (
										<div>
											<div className="d-md-flex align-items-center">
												<div className="ml-auto d-flex no-block align-items-center">
													<ul className="list-inline font-12 dl mr-3 mb-0">
														{/*<li className="border-0 p-0 text-info list-inline-item">*/}
														{/*	<i className="fa fa-circle"></i> TT*/}
														{/*</li>*/}
													</ul>
													<div className="dl">
														{/*<Input type="select" className="custom-select">*/}
														{/*	<option value="0">Monthly</option>*/}
														{/*	<option value="1">Daily</option>*/}
														{/*	<option value="2">Weekly</option>*/}
														{/*	<option value="3">Yearly</option>*/}
														{/*</Input>*/}
													</div>
												</div>
											</div>
											<Row className="stat-graf">
												<Col lg="12">
													<div className="campaign ct-charts">
														<div className="chart-wrapper"
															 style={{ width: '100%', margin: '0 auto', height: 350 }}>
															<Line
                                                                data={{
                                                                    datasets: pointsDataSets,
                                                                    labels: pointsLabels
                                                                }}
                                                                datasetKeyProvider={() => `${nanoid()}`}
                                                                options={{
                                                                    maintainAspectRatio: false,
                                                                    legend: {
                                                                        display: false,
                                                                        labels: { fontFamily: "Nunito Sans" }
                                                                    },
                                                                    scales: {
                                                                        yAxes: [{
                                                                            stacked: true,
                                                                            gridLines: { display: false },
                                                                            ticks: {
                                                                                fontFamily: "Nunito Sans",
                                                                                beginAtZero:true,
                                                                                min: 0,
                                                                                stepSize: (Math.max(dataValue) / 2).toFixed()
                                                                            }
                                                                        }],
                                                                        xAxes: [{
                                                                            stacked: true,
                                                                            gridLines: { display: false },
                                                                            ticks: {
                                                                                fontFamily: "Nunito Sans",
                                                                                stepSize: 1,
                                                                                beginAtZero:true
                                                                            }
                                                                        }]
                                                                    }
                                                                }}
															/>
														</div>
													</div>
												</Col>
											</Row>
											<Row>
												<Col lg="12">
													<FormGroup>
														<Input
															className="store-search-filter"
															type="text"
															name="search"
															id="search"
															value={this.state.login}
															onChange={this.onFilterClick}
															placeholder={I18n[lang].point.placeholder}
														/>
														<Datetime
															className="store-data-filter"
															locale="en-gb"
															timeFormat={false}
															closeOnSelect={true}
															inputProps={{ placeholder: `${I18n[lang].point.dateFrom}`, readOnly:true }}
															onChange={this.dateFromTimeChange}
															value={this.state.dateFrom? moment(this.state.dateFrom).format('DD.MM.YYYY'): ''}
														/>
														<Datetime
															className="store-data-filter date-to"
															locale="en-gb"
															timeFormat={false}
															closeOnSelect={true}
															inputProps={{ placeholder: `${I18n[lang].point.dateTo}`, readOnly:true }}
															onChange={this.dateToTimeChange}
															value={this.state.dateTo? moment(this.state.dateTo).format('DD.MM.YYYY'): ''}
														/>
                                                        <div className="company-btn__group">
															<Button
																color="primary"
																type="button"
																className="company-btn btn-filter"
																onClick={this.getFiltered}
															>
																{I18n[lang].point.filter}
															</Button>
															<Button
																color="primary"
																type="button"
																className="company-btn btn-clear"
																onClick={this.clearFilters}
															>
																{I18n[lang].point.resetFilter}
															</Button>
														</div>
													</FormGroup>
												</Col>
											</Row>
											<div className="stat-table">
												<ReactTable
													getProps={() => {
														return {
															style: {
																border: "none",
																padding: "5px"
															}
														};
													}}
													getTheadProps={() => {
														return {
															style: {
																boxShadow: "none",
																padding: "10px 0",
																fontWeight: "800"
															}
														};
													}}
													getTheadThProps={() => {
														return {
															style: {
																borderRight: "none"
															}
														};
													}}
													getTdProps={() => {
														return {
															style: {
																borderRight: "none",
																textAlign: "center"
															}
														};
													}}
													getTrProps={() => {
														return {
															style: {
																alignItems: "center"
															}
														};
													}}
													getNoDataProps={() => {
														return {
															style: {
																top: "100%"
															}
														};
													}}
													columns={[
														{
															Header: "#",
															accessor: "count_id",
															sortable: false,
															filterable: false,
															style: {
																textAlign: "left",
																fontSize: "0.7rem",
																textTransform: "lowercase"
															},
															maxWidth: 40,
															Cell: (row) => {
																return <div>{row.index + 1}</div>;
															}
														},
														{
															Header: `${I18n[lang].point.producer}`,
															accessor: "producer",
															sortable: false,
															filterable: false,
															maxWidth: 250,
															style: {
																textAlign: "left",
															}
														},
														{
															Header: `${I18n[lang].point.model}`,
															accessor: "model",
															sortable: false,
															filterable: false,
															maxWidth: 250,
															style: {
																fontSize: "0.7rem",
																textTransform: "lowercase",
															}
														},
														{
															Header: `${I18n[lang].point.imei}`,
															accessor: "imei",
															sortable: false,
															filterable: false,
															style: {
																fontSize: "0.7rem",
																textAlign: "center"
															},
														},
														{
															Header: `${I18n[lang].point.serial}`,
															accessor: "serial",
															sortable: false,
															filterable: false,
															style: {
																fontSize: "0.7rem",
																textAlign: "center"
															},
														},
														{
															Header: `${I18n[lang].point.version}`,
															accessor: "version",
															sortable: false,
															filterable: false,
															maxWidth: 150,
															style: {
																fontSize: "0.7rem",
																textAlign: "center"
															},
														},
														// {
														// 	Header: `${I18n[lang].point.pack}`,
														// 	accessor: "pocket",
														// 	sortable: false,
														// 	filterable: false,
														// 	style: {
														// 		fontSize: "0.7rem",
														// 		textAlign: "center"
														// 	},
														// },
														// {
														// 	Header: `${I18n[lang].point.status}`,
														// 	accessor: "status",
														// 	sortable: false,
														// 	filterable: false,
														// 	maxWidth: 110,
														// 	style: {
														// 		fontSize: "0.7rem",
														// 		textAlign: "center"
														// 	},
														// },
														{
															Header: `${I18n[lang].point.install}`,
															accessor: "time",
															sortable: false,
															filterable: false,
															style: {
																fontSize: "0.7rem",
																textAlign: "center"
															},
														},
													]}
													PaginationComponent={Pagination}
													nextText={">>"}
													previousText={"<<"}
													pageSize={100}
													minRows={0}
													defaultPageSize={-1}
													showPaginationBottom={!!(tableData.length && tableData.length > 100)}
													className="-highlight"
													data={tableData}
													filterable
												/>
											</div>
										</div>

									)
								}
							})()
						}
					</CardBody>
				</Card>
			</div>
		)
	}
};

const mapDispatchToProps = dispatch => {
	return {
		closeAlert: () => dispatch(closeAlert()),
		fetchCompanies: (query) => dispatch(fetchCompanies(query)),
		fetchStoreStats: (storeId, query) => dispatch(fetchStoreStats(storeId, query)),
        filteringStoreStats: word => dispatch(filteringStoreStats(word)),
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	companies: state.companiesReducer.companies,
	authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
	stats: state.storeStatsReducer.storeStats,
	uploadReports: state.storeStatsReducer.uploadReports,
    filteredStats: state.storeStatsReducer.filteredStoreStats,
    loading: state.companyStatsReducer.loading,
	lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreStat)



// WEBPACK FOOTER //
// ./src/components/Statistics/StoreStat/StoreStat.js